import React from "react";
import { useState, useEffect } from "react";
import { openNotification } from "swfrontend/COMS/NotificationMessageMapping";
import { Form, Divider, Input, Select, Table, DatePicker } from 'antd';
import EmployeeSearchBox from "../../../Components/EmployeeSearchBox";
import SupplierSearchBox from "../../../Components/SupplierSearchBox"
import { DataProvider } from "../../DataProvider";
import ReactSpeedometer from "react-d3-speedometer";
var _ = require('lodash');

const GeneralDetails = ({ formRef, disabled, initialValues }) => {

    const dataProvider = new DataProvider()
    const [weightedScore, setWeightedScore] = useState(initialValues && initialValues.hasOwnProperty('overall_score') && initialValues['overall_score']?parseFloat(initialValues['overall_score'].split(' - ')[0]):0)
    const [mstLocation, setMstLocation] = useState([]);
    const [mstProgram, setMstProgram] = useState([]);
    const [mstProject, setMstProject] = useState([]);
    const [mstPurchaseOrder, setMstPurchaseOrder] = useState([]);
    const [projectHeadFound, setProjectHeadFound] = useState(true);
    const [programHeadFound, setProgramHeadFound] = useState(true);

    const columns = [
        {
            title: 'Category',
            dataIndex: 'category',
        },
        {
            title: 'Weightage',
            dataIndex: 'weightage',
            align: "center",
            key: 'weightage',
            width: 200,
        },
        {
            title: 'Score',
            dataIndex: 'score',
            align: "center",
            key: 'score',
            width: 200,
        },
        {
            title: 'Weighted Score',
            dataIndex: 'weighted_score',
            align: "center",
            key: 'weighted_score',
            width: 200,
        },
    ];

    const masterDataMapping = {
        "MstLocation": setMstLocation,
        "MstProgram": setMstProgram,
        "MstProject": setMstProject,
        "MstPurchaseOrder": setMstPurchaseOrder
    };

    const fetchDropdownValues = () => {
        ['MstLocation', 'MstProgram', 'MstProject'].forEach((model, index) => {
            dataProvider.getDropdownValues(model)
                .then((response) => {
                    if (response.ok) {
                        response.json().then((data) => {
                            const setter = masterDataMapping[model];
                            setter(data.results)
                        })
                    } else {
                        response.json().then((responseJson) => {
                            openNotification("error", "Error", responseJson["message"]);
                        });
                    }
                }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
        })
    }

    const fetchDependentDropdownValues = (model, filter, value, callback) => {
        dataProvider.getDependentDropdownValues(model, filter + value).then((response) => {
            if (response.ok) {
                response.json().then((data) => {
                    const setter = masterDataMapping[model];
                    setter(data.results)
                    callback(value)
                })
            } else {
                response.json().then((responseJson) => {
                    openNotification("error", "Error", responseJson["message"]);
                });
            }
        }).catch((exception) => openNotification("error", "Error", "Error connecting server"))
    };


    useEffect(() => {
        fetchDropdownValues();
    }, []);

    const setProgramHead = (value) => {
        const selectedObj = mstProgram.filter(item => item.program_id == value)
        if (selectedObj['0']['program_head'].length > 0) {
            formRef.current.setFieldValue('program_head', JSON.parse(selectedObj['0']['program_head'])['label'])
            setProgramHeadFound(true)
        } else {
            setProgramHeadFound(false)
        }
    }

    const setProjectHead = (value) => {
        const selectedObj = mstProject.filter(item => item.project_id == value)
        if (selectedObj['0']['project_head'].length > 0) {
            formRef.current.setFieldValue('project_head', JSON.parse(selectedObj['0']['project_head'])['label'])
            setProjectHeadFound(true)
        } else {
            setProjectHeadFound(false)
        }
    }


    return (
        <>
            {!(initialValues && initialValues.hasOwnProperty('overall_score') && initialValues['overall_score']) &&
                <><div className="col-lg-6 col-md-12">
                    <Form.Item
                        name={"evaluation_period"}
                        label="Evaluation Period"
                        rules={[{ required: true, message: "Please select Evaluation Period" }]}>
                        <DatePicker disabled={disabled} format={"MMMM - YYYY"} picker="month" style={{ width: "100%" }} />
                    </Form.Item>
                </div><div className="col-lg-6 col-md-12"></div></>}
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="location" label="Location">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Location"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => fetchDependentDropdownValues('MstProgram', 'location.location_id=', value)}
                        options={mstLocation.map((val) => ({
                            value: val.location_id,
                            label: val.location_name,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                {disabled &&
                    <Form.Item
                        name={"created_by"}
                        label="Submitted by">
                        <Input disabled={disabled} />
                    </Form.Item>}
            </div>
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="program" label="Program">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Program"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => fetchDependentDropdownValues('MstProject', 'program.program_id=', value, setProgramHead)}
                        options={mstProgram.map((val) => ({
                            value: val.program_id,
                            label: val.program_name,
                        }))} />
                </Form.Item>
            </div>
            <div className="col-lg-6 col-md-12">
                {programHeadFound ?
                    <Form.Item
                        name={"program_head"}
                        label="Program Head"
                        rules={[{ required: true, message: "Please enter Program Head" }]}>
                        <Input disabled={true} />
                    </Form.Item> :
                    <Form.Item
                        name={"program_head"}
                        label="Program Head"
                        rules={[{ required: true, message: "Please enter Program Head" }]}>
                        <EmployeeSearchBox
                            initialValues={initialValues}
                            formRef={formRef}
                            mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                            decorator="program_head"
                            disabled={disabled}
                            placeholder="Enter Program Head" />
                    </Form.Item>}

            </div>
            {!(initialValues && initialValues.hasOwnProperty('overall_score') && initialValues['overall_score']) &&
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="project" label="Project">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Project"
                        disabled={disabled}
                        optionFilterProp="label"
                        onSelect={(value) => setProjectHead(value)}
                        options={mstProject.map((val) => ({
                            value: val.project_id,
                            label: val.project_name,
                        }))} />
                </Form.Item>
            </div>}
            <div className="col-lg-6 col-md-12">
                {projectHeadFound ?
                    <Form.Item
                        name={"project_head"}
                        label="Project Head"
                        rules={[{ required: true, message: "Please enter Project Head" }]}>
                        <Input disabled={true} />
                    </Form.Item> :
                    <Form.Item
                        name={"project_head"}
                        label="Project Head"
                        rules={[{ required: true, message: "Please enter Project Head" }]}>
                        <EmployeeSearchBox
                            initialValues={initialValues}
                            formRef={formRef}
                            mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                            decorator="project_head"
                            disabled={disabled}
                            placeholder="Enter Project Head" />
                    </Form.Item>}
            </div>
            
            {!(initialValues && initialValues.hasOwnProperty('overall_score') && initialValues['overall_score']) &&
            <><Divider /><div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"contractor_name"}
                    label="Contractor Name"
                    rules={[{ required: true, message: "Please enter Contractor Name" }]}>
                    <SupplierSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        callback={(value) => fetchDependentDropdownValues('MstPurchaseOrder', 'vendor_code=', value['key'])}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="contractor_name"
                        disabled={disabled}
                        placeholder="Enter Contractor Name" />
                </Form.Item>
            </div></>}
            <div className="col-lg-6 col-md-12">
                <Form.Item required name="work_order_no" label="Work Order No">
                    <Select
                        allowClear
                        showSearch
                        placeholder="Select Work Order No"
                        disabled={disabled}
                        optionFilterProp="label"
                        options={mstPurchaseOrder.map((val) => ({
                            value: val.purchase_order_number,
                            label: val.purchase_order_number,
                        }))} />
                </Form.Item>
            </div>
            {/* 
            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"work_order_value"}
                    label="Work Order Value">
                    <InputNumber
                        formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        parser={(value) => value.replace(/\$\s?|(,*)/g, '')}
                        style={{ width: "100%" }}
                        prefix="₹"
                        disabled={disabled}
                        placeholder="Enter Work Order Value" />
                </Form.Item>
            </div> */}
            <Divider />
            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"section_head"}
                    label="Section Head">
                    <EmployeeSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="section_head"
                        disabled={disabled}
                        placeholder="Enter Section Head" />
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"safety_head"}
                    label="Safety Head"
                    rules={[{ required: true, message: "Please enter Safety Head" }]}>
                    <EmployeeSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="safety_head"
                        disabled={disabled}
                        placeholder="Enter Safety Head" />
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"qa_qc_head"}
                    label="QA/QC Head"
                    rules={[{ required: true, message: "Please enter QA/QC Head" }]}>
                    <EmployeeSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="qa_qc_head"
                        disabled={disabled}
                        placeholder="Enter QA/QC Head" />
                </Form.Item>
            </div>

            <div className="col-lg-6 col-md-12">
                <Form.Item
                    name={"pmc"}
                    label="PMC"
                    rules={[{ required: true, message: "Please enter PMC" }]}>
                    <EmployeeSearchBox
                        initialValues={initialValues}
                        formRef={formRef}
                        mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                        decorator="pmc"
                        disabled={disabled}
                        placeholder="Enter PMC" />
                </Form.Item>
            </div>
            {initialValues && initialValues.hasOwnProperty('overall_score') && initialValues['overall_score'] &&
                <>
                    <Divider />
                    <div className=" col-lg-6 col-md-12">
                        <Form.Item
                            name={"contractor_name"}
                            label="Contractor Name"
                            rules={[{ required: true, message: "Please enter Contractor Name" }]}>
                            <SupplierSearchBox
                                initialValues={initialValues}
                                formRef={formRef}
                                callback={(value) => fetchDependentDropdownValues('MstPurchaseOrder', 'vendor_code=', value['key'])}
                                mode="SECRET_COMBOBOX_MODE_DO_NOT_USE"
                                decorator="contractor_name"
                                disabled={disabled}
                                placeholder="Enter Contractor Name" />
                        </Form.Item>
                        <Form.Item
                            name={"evaluation_period"}
                            label="Evaluation Period"
                            rules={[{ required: true, message: "Please select Evaluation Period" }]}>
                            <DatePicker disabled={disabled} format={"MMMM - YYYY"} picker="month" style={{ width: "100%" }} />
                        </Form.Item>
                        <Form.Item required name="project" label="Project">
                            <Select
                                allowClear
                                showSearch
                                placeholder="Select Project"
                                disabled={disabled}
                                optionFilterProp="label"
                                onSelect={(value) => setProjectHead(value)}
                                options={mstProject.map((val) => ({
                                    value: val.project_id,
                                    label: val.project_name,
                                }))} />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-md-12" style={{ textAlign: "center" }}>
                        <ReactSpeedometer
                            currentValueText="Rating Scale"
                            customSegmentStops={[0, 2, 3, 3.5, 4]}
                            segmentColors={["firebrick", "tomato", "gold", "limegreen"]}
                            minValue={0}
                            maxValue={4}
                            height={200}
                            value={initialValues['overall_score'].split(' - ')[0]}
                        />
                    </div>
                    <Divider />
                    <div className="col-lg-6 col-md-12">
                        <Form.Item
                            name={"overall_score"}
                            extra={<p style={{ fontSize: "13px", paddingLeft: "10px" }}>
                                (0-2)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bronze<br />
                                (2-3)&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Silver<br />
                                (3-3.5)&nbsp;&nbsp;&nbsp;&nbsp;Gold<br />
                                (3.5-4)&nbsp;&nbsp;&nbsp;&nbsp;Diamond<br />
                            </p>}
                            label="Overall Score">
                            <Input 
                                readOnly
                                style={{ color:"white", fontWeight:"bold", background: weightedScore <=2 ? '#b22222' : weightedScore <=3 ? '#ff6347': weightedScore <=3.5 ? '#ffd700': '#32cd32' }}
                              />
                        </Form.Item>
                    </div>
                    <div className="col-lg-6 col-md-12">
                        <Table
                            style={{ marginBottom: "15px" }}
                            bordered={true}
                            columns={columns}
                            size="small"
                            pagination={false}
                            dataSource={_.cloneDeep(initialValues['score_summary'])} />
                    </div>
                </>}
        </>
    )
}

export default GeneralDetails;